import React, { FC, useState } from "react";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";

import classes from "../../CampaignsDashboard.module.scss";
import { CampaignType } from "../../../../../types/campaignTypes";
import { SelectOptionType } from "../../../../../components/elements/Select/Select";

type CampaignsSelectorProps = {
  selectedCampaign: CampaignType;
  options: SelectOptionType[];
  handleChangeSelectedCampaign: (value: SelectOptionType | null) => void;
};

const CampaignsSelector: FC<CampaignsSelectorProps> = ({ selectedCampaign, options, handleChangeSelectedCampaign }) => {
  const [inputValue, setInputValue] = useState<string>("");

  return (
    <Autocomplete
      className={classes.selector}
      defaultValue={options.find((option) => option.value === selectedCampaign.brandgenCampaignId)}
      onChange={(event: React.ChangeEvent<{}>, newValue: SelectOptionType | null) => {
        handleChangeSelectedCampaign(newValue);
      }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
      options={options}
      disableClearable
      getOptionLabel={(option) => option.label || ""}
      renderInput={(params) => <TextField {...params} label="Campaigns" variant="outlined" />}
    />
  );
};

export default CampaignsSelector;
